import React from 'react';
import './index.scss';

const Pagination = ({ count, currentPage, handlePageChange, limit = 20 }) => {
  const totalPages = Math.ceil(count / limit);
  let pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((e) => {
    if (
      e === 1 ||
      e === totalPages ||
      (e > currentPage - 3 && e < currentPage + 3)
    ) {
      return (
        <li
          key={e}
          className={'loader-page-item' + (currentPage === e ? ' active' : '')}
          onClick={() => handlePageChange(e)}
        >
          <span>{e}</span>
        </li>
      );
    }

    if (e === currentPage - 3 || e === currentPage + 3) return ' ... ';
    return null;
  });

  return (
    <div className="pagination justify-content-center ">
      <div className="col-12 col-sm-6 d-flex justify-content-center">
        <ol className="loader-page swipe-to-top">
          <li
            className="loader-page-item"
            onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
          >
            <span>
              <i className="fa fa-angle-double-left" style={{ fontSize: 12 }} />
            </span>
          </li>
          {renderPageNumbers}
          <li
            className="loader-page-item"
            onClick={() =>
              currentPage < totalPages && handlePageChange(currentPage + 1)
            }
          >
            <span>
              <i
                className="fa fa-angle-double-right"
                style={{ fontSize: 12 }}
              />
            </span>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Pagination;
